import React, { useEffect, useState } from 'react';
import { Box, Grid, LinearProgress, Typography, makeStyles } from '@material-ui/core'
import { Rating } from '@material-ui/lab'
import DataService from "../../../../../Service";
import MaterialTable from 'material-table';
import useDebounce from "../../../../../Components/debounce";

const EvaluationForm = (props) => {

  const { id } = props
  const [recievedDate, setRecievedDate] = useState("");
  const [evalutionList, setEvalutionList] = useState([]);
  const [totalCount, setTotalCount] = useState(1000);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [searchTextSelect, handleSearchText] = useState(null);
  const [apiData, setApiData] = useState([]);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);

  const getData = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: debouncedSearchText || null,
      assignment_id: id
    }
    DataService.getDirectData('/evaluation_forms/assignment_evaluation_form_summary', params).then((res) => {
      if (res) {
        setApiData(res.evaluation_form.evaluation_form_details);
        setTotalCount(res.total_count)
        setRecievedDate(res.evaluation_form.evaluation_form_received_date)
      }
    }).catch((error) => console.log(error))
  };
  useEffect(() => {
    getData();
  }, [page, pageSize, debouncedSearchText]);
  const columns = [

    {
      field: "question",
      title: <span textAlign="left" fontWeight="fontWeightBold" style={{ color: "#077F83" }}>Question </span>,
    },
    {
      field: "rating",
      title: <span textAlign="left" fontWeight="fontWeightBold" style={{ color: "#077F83" }}>Response </span>,
      render: rowData => rowData.question_type === "rating" ? <Rating name="read-only" value={rowData.rating} readOnly /> : rowData.answer
    },
    {
      field: "comment",
      title: <span textAlign="left" fontWeight="fontWeightBold" style={{ color: "#077F83" }}>Additional comments (if any) </span>,
      render: rowData => rowData.question_type === "rating" ? rowData.answer : ""

    },

  ];
  const options = {
    search: false,
    emptyRowsWhenPaging: false,
    searchFieldAlignment: 'right',
    total: totalCount,
  
    pageSizeOptions:[20,50,75,100],
            headerStyle: {
              position: "sticky",
              top: "0",
              fontSize: "14px",
              fontWeight: '200',
            },
            maxBodyHeight: "600px" ,
    page: page,
    pageSize: pageSize,
  };
  return <Box >
    <Grid container direction="row">

      <Grid item xs={12}>
        <Typography variant="subtitle1" style={{ color: "#232323" }}>
          <Box textAlign="left" mt={2} fontWeight="fontWeightBold">
            Evaluation form received date
          </Box>
        </Typography>
        <Typography variant="h2" style={{ color: "#707070CC" }}>
          <Box textAlign="left" mt={1}>
            {recievedDate}
          </Box>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
          <Box textAlign="left" my={2} fontWeight="fontWeightBold" >
            Evaluation form details
          </Box>
        </Typography>

      </Grid>
      <Grid item xs={12}>

        <MaterialTable
          // title={<Typography variant="h2" style={{ fontWeight: "bold" }}>Evaluation Form</Typography>}
          title={""}
          data={apiData}
          columns={columns}
          options={options}
          totalCount={totalCount}
          page={page}
          onChangePage={(page) => {
            setPage(page);
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onSearchChange={(search) => {
            setSearchText(search);
          }}

        />
      </Grid>
    </Grid>
  </Box>
}

export default EvaluationForm
